<template>
	<CampaignLayout :subtitle="trans('tools.campaigns.edit.title')" :campaign="campaign">
		<template #actions>
			<Link :as="SecondaryButton" :color="Color.Blue" :href="route('tools.campaigns.show', campaign.id)">
				<i class="fa-solid fa-eye mr-2"/>
				{{ trans('tools.campaigns.preview') }}
			</Link>
			<PrimaryButton :color="Color.Green" @click.stop="save(campaign)">
				<i class="fa-solid fa-check mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<LabeledObject>
			<template #label>{{ trans('tools.campaigns.subject') }}</template>
			<input v-model="campaign.subject" type="text">
		</LabeledObject>
		<TextEditor v-model="campaign.content" bordered/>
	</CampaignLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import CampaignLayout from '@/Layouts/CampaignLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import TextEditor from '@/Components/UI/Editor/TextEditor.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'

const props = defineProps<{
	campaign:Campaign,
}>()

const working:Ref<boolean> = ref(false)
const campaign:Ref<Campaign> = ref(props.campaign)

function save(campaign:Campaign):void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('tools.campaigns.update', campaign.id), campaign).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>